export default "__VITE_ASSET__c2aa7eb3__"